import { FC, useEffect, useState } from "react";
import { CompatibilityDetails as CompatibilityDetailsType } from "../Compatibility.type";
import { CompatibilitySection } from "../CompatibilitySection/CompatibilitySection";
import { CompatibilityDescription } from "../CompatibilityDescription/CompatibilityDescription";

type Props = {
  isLoadingCompatibility: boolean;
  users: CompatibilityDetailsType[];
  compatibilityByUser: any[];
  selectedUserForIndividualReport: string;
  compatibilityGraph: string;
};

export const CompatibilityDetails: FC<Props> = ({
  users,
  compatibilityByUser,
  selectedUserForIndividualReport,
  compatibilityGraph,
  isLoadingCompatibility,
}) => {
  const [selectedUser, setSelectedUser] = useState<
    CompatibilityDetailsType | undefined
  >(users[0]);

  useEffect(() => {
    setSelectedUser(users[0]);
  }, [users]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "50% 50%",
        gap: 30,
        color: "white",
      }}
    >
      <CompatibilitySection
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
      />

      <CompatibilityDescription
        isLoading={isLoadingCompatibility}
        name={selectedUser?.name || ""}
        description={selectedUser?.description}
        compatibilityByUser={compatibilityByUser}
        selectedUserForIndividualReport={selectedUserForIndividualReport}
        compatibilityGraph={compatibilityGraph}
      />
    </div>
  );
};
